import React from 'react';
import { makeStyles } from '@material-ui/core';
import { MachinePlannedStop, QualityOutOfSpec, MachineUnPlannedStop, MachineStart, ScissorScrap, ScissorProduction, UnKnownQualityCheckType } from '../../Config/constants';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function MessageContent(props) {
    const classes = useStyles();

    let notificationType = "";

    const formatDate = (date) => {
        // format date to dd/mm/yyyy - hh:mm
        let dateObj = new Date(date);
        let formattedDate = "";

        // if minutes is less than 10 add a 0 in front of it
        let minutes = dateObj.getMinutes() < 10 ? "0" + dateObj.getMinutes() : dateObj.getMinutes();

        formattedDate = dateObj.getDate() + "/" + (dateObj.getMonth() + 1) + "/" + dateObj.getFullYear() + " - " + dateObj.getHours() + ":" + minutes;




        // formattedDate = dateObj.getDate() + "/" + dateObj.getMonth() + "/" + dateObj.getFullYear() + " - " + dateObj.getHours() + ":" + dateObj.getMinutes();

        return formattedDate;
    };

    switch (props.message.notificationTypeId) {
        case MachinePlannedStop:
            notificationType = "info";
            break;
        case MachineUnPlannedStop:
            notificationType = "error";
            break;
        case MachineStart:
            notificationType = "info";
            break;
        case QualityOutOfSpec:
            notificationType = "error";
            break;
        case ScissorScrap:
            notificationType = "info";
            break;
        case ScissorProduction:
            notificationType = "info";
            break;
        case UnKnownQualityCheckType:
            notificationType = "error";
            break;
        default:

    }

    const notificationTypeClass = notificationType ? `${notificationType}` : '';

    return (
        <div className={classes.message}>
            <div className={classes.message__lineContainer}>
                <div className={classes.message__indicator} />
                <div className={classes.message__line} />
            </div>
            <div className={classes.message__content}>
                <div className={classes.message__header}>
                    <p className={classes.message__machine}>{props.message.machineName ? props.message.machineName : "MachineId: " + props.message.machineId}</p>
                    <p className={classes.message__time}>{formatDate(props.message.insertedOn)}</p>
                </div>
                {props.message.message &&
                    <div className={`${classes.message__errorMessage} error`}>
                        {/* <div className={classes.icon} style={{ color: iconColor, paddingTop: props.iconPadding }}>{icon}</div> */}
                        <p className={classes.message__errorText}>{props.message.message}</p>
                    </div>
                }
                {props.message.translatedMessage &&
                    // multiple classes
                    <div className={`${classes.message__errorMessage} ${notificationTypeClass}`}>
                        <p className={classes.message__errorText}>{props.message.translatedMessage}</p>
                    </div>
                }
            </div>

        </div>
    )

}

const useStyles = makeStyles(() => ({
    message: {
        width: "100%",
        height: "auto",
        display: 'flex',
        gap: "16px",
    },

    message__lineContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        marginTop: '6px',
    },

    message__indicator: {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#fff',
    },

    message__line: {
        width: '1px',
        height: '100%',
        backgroundColor: '#fff',
    },

    message__content: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px",
        paddingBottom: "22px",
    },

    message__header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    message__machine: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: FlagstoneTheme.palette.text.primary,
        margin: "0px",
    },

    message__time: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: FlagstoneTheme.palette.text.tertiary,
        margin: "0px",
    },

    message__body: {
        width: "100%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: FlagstoneTheme.palette.text.primary,
    },

    message__errorMessage: {
        width: "100%",
        boxSizing: "border-box",
        padding: "8px",
        borderRadius: "3px",

        "&.info": {
            backgroundColor: "#DEE8FF",
            border: "1px solid #4654FB",

            color: "#4654FB",
        },

        "&.error": {
            backgroundColor: "#FDF3F3",
            border: "1px solid #D84949",

            color: "#D84949",
        }
    },

    message__errorText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',

        margin: "0px",
    },

    icon: {
        float: "left",
        marginRight: "20px"
    },
    text: {
        float: "left",
        paddingTop: "3px"
    },


    dateTime: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginTop: "10px"
    },
}));